import { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { EventTileGroup } from 'components/UI/EventTileGroup/EventTileGroup';
import { EventTile } from 'components/UI/EventTile/EventTile';
import { Loading } from 'components/UI/Loading/Loading';
import { hasFeatureEvent } from 'utils';
import { endpoints } from 'utils/global-constants';
import './UpcomingEvents.scss';

export const UpcomingEvents = (props) => {
  const { sectionTitle } = props;
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const classes = ['upcoming-events', isLoading ? 'upcoming-events--is-loading' : ''].join(' ');

  const fetchEvents = async () => {
    try {
      const response = await axios.get(endpoints.getUpcomingEvents);
      const formattedEvents = response?.data?.events;
      setEvents(formattedEvents);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const upcomingEventsContent = (
    <div className="upcoming-events__container container">
      <h2 className="upcoming-events__heading h3">{sectionTitle}</h2>
      <EventTileGroup hasFeaturedTile={hasFeatureEvent(events)}>
        {events?.map((event, index) => (
          <EventTile {...event} key={index} />
        ))}
      </EventTileGroup>
    </div>
  );

  return (
    <section className={classes} data-testid="upcoming-events">
      {isLoading ? <Loading /> : upcomingEventsContent}
    </section>
  );
};

export const UpcomingEventsSC = (props) => {
  const { sitecoreData } = props;
  return <UpcomingEvents {...sitecoreData} />;
};

UpcomingEvents.propTypes = {
  sectionTitle: PropTypes.string,
};

UpcomingEventsSC.propTypes = {
  sitecoreData: PropTypes.object,
};
